import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const userFilter = createAsyncThunk('userFilter', async (data) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `user_search`,
            params: {
                search: data?.search || '',
                page: data?.page || 1,
                limit: data?.limit || 10
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const userFilterSlice = createSlice({
    name: 'userFilter',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(userFilter.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(userFilter.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default userFilterSlice.reducer; 